import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  InputLabel,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FieldsResponse } from "@/modules/common/dtos/index.v2";
import Grid from "@mui/material/GridLegacy";

interface BooleanDropdownRendererProps {
  formFields: FieldsResponse[];
}

const BooleanDropdownRenderer: React.FC<BooleanDropdownRendererProps> = ({
  formFields,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {formFields
        ?.filter((field) => field.field.type === "boolean")
        .map((field) => {
          const rules: Record<string, any> = {};
          if (field.required) {
            rules.required = true;
          }

          if (field.field.defaultValue) {
            rules.defaultValue = field.field.defaultValue === "true";
          }

          const name = field.field.key || field.field.uid;

          return (
            <Grid item mobile={6} container key={field.id}>
              <Controller
                name={name}
                control={control}
                defaultValue={
                  rules.defaultValue
                    ? {
                        value: true,
                      }
                    : null
                }
                render={({ field: { onChange, value, ref } }) => (
                  <FormControl fullWidth error={!!errors[name]}>
                    <InputLabel id={`${name}-label`}>
                      {field.field.label}
                    </InputLabel>
                    <Select
                      labelId={`${name}-label`}
                      value={
                        (value?.value ?? rules.defaultValue)?.toString() || ""
                      }
                      required={rules.required}
                      onChange={(e) => {
                        onChange({ value: e.target.value });
                      }}
                      inputRef={ref}
                      label={field.field.label}
                    >
                      <MenuItem value="true">Yes</MenuItem>
                      <MenuItem value="false">No</MenuItem>
                    </Select>
                    {errors[name] && (
                      <Typography
                        color="error"
                        variant="caption"
                        style={{ marginTop: "3px" }}
                      >
                        {errors[name]?.message as string}
                      </Typography>
                    )}
                  </FormControl>
                )}
              />
            </Grid>
          );
        })}
    </>
  );
};

export default BooleanDropdownRenderer;
